import React, { useState } from 'react';
import { ShieldCheckIcon, ClockIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface PricingSectionProps {
  id?: string;
}
export function PricingSection({
  id = 'pricing'
}: PricingSectionProps) {
  const [selectedPack, setSelectedPack] = useState<1 | 2>(2);
  const packs = {
    1: {
      name: 'MEGA PACK INGRESO A LAS FUERZAS',
      subtitle: 'Pack completo + 5 bonos',
      originalPrice: '$39.990',
      currentPrice: '$19.990',
      icon: '⚡',
      link: 'https://mi-tienda-2-8952.myshopify.com/cart/51601260216640:1'
    },
    2: {
      name: 'MEGA PACK + GUÍA PSICOLÓGICA',
      subtitle: 'Todo lo anterior + Guía Psicológica',
      originalPrice: '$49.990',
      currentPrice: '$25.990',
      icon: '🏆',
      savings: '$24.000',
      link: 'https://mi-tienda-2-8952.myshopify.com/cart/51601260511552:1'
    }
  };
  const handlePurchase = () => {
    window.location.href = packs[selectedPack].link;
  };
  return <section id={id} className="py-8 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        {/* Header */}
        <div className="text-center mb-5" data-id="element-126">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-2" data-id="element-127">
            <span className="italic font-normal" data-id="element-128">Elegí tu</span>{' '}
            <span className="text-green-500" data-id="element-129">MEGA PACK:</span>
          </h2>
          <p className="text-base md:text-lg text-gray-400" data-id="element-130">
            Todas las opciones incluyen los 5 bonos exclusivos
          </p>
        </div>

        {/* Pack Options */}
        <div className="flex flex-col gap-2 mb-5" data-id="element-131">
          {([1, 2] as const).map(packId => {
          const isSelected = selectedPack === packId;
          const pack = packs[packId];
          return <motion.div key={packId} whileTap={{
            scale: 0.98
          }} onClick={() => setSelectedPack(packId)} className={`cursor-pointer rounded-xl px-3 py-2.5 transition-all duration-300 border-2 ${isSelected ? 'border-green-500 bg-gray-900/80 shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-gray-800 bg-black hover:border-gray-700'}`} data-id="element-132">
                <div className="flex items-center justify-between gap-3" data-id="element-133">
                  <div className="flex items-center gap-2.5 min-w-0" data-id="element-134">
                    <div className="flex-shrink-0" data-id="element-135">
                      <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-green-500' : 'border-gray-600'}`} data-id="element-136">
                        {isSelected && <div className="w-2.5 h-2.5 bg-green-500 rounded-full" data-id="element-137" />}
                      </div>
                    </div>

                    <div className="min-w-0" data-id="element-138">
                      <div className="flex items-center gap-1.5 flex-wrap" data-id="element-139">
                        <span className="text-base" data-id="element-140">{pack.icon}</span>
                        <h3 className="text-sm md:text-base font-bold text-white uppercase leading-tight" data-id="element-141">
                          {pack.name}
                        </h3>
                      </div>

                      {packId === 2 && <div className="flex flex-wrap items-center gap-1.5 mt-0.5" data-id="element-142">
                          <span className="bg-green-500 text-black text-[9px] sm:text-[10px] font-bold px-1.5 py-px rounded uppercase tracking-wider flex items-center gap-0.5" data-id="element-143">
                            <span className="text-xs" data-id="element-144">⭐</span> MÁS ELEGIDO
                          </span>
                          <span className="bg-green-500/10 text-green-400 text-[9px] sm:text-[10px] font-bold px-1.5 py-px rounded uppercase tracking-wider border border-green-500/20" data-id="element-145">
                            AHORRÁS {pack.savings}
                          </span>
                        </div>}

                      <p className="text-xs text-gray-400 mt-0.5" data-id="element-146">
                        {pack.subtitle}
                      </p>
                    </div>
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-147">
                    <div className="text-xs text-gray-500 line-through font-medium" data-id="element-148">
                      {pack.originalPrice}
                    </div>
                    <div className="text-2xl md:text-3xl font-black text-green-400 tracking-tight leading-none" data-id="element-149">
                      {pack.currentPrice}
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* CTA Button */}
        <div className="max-w-2xl mx-auto text-center mb-6" data-id="element-150">
          <button onClick={handlePurchase} className="w-full bg-green-500 text-black text-lg md:text-xl font-black uppercase tracking-wider py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] hover:bg-green-400 shadow-[0_0_30px_rgba(34,197,94,0.3)] mb-3" data-id="element-151">
            SÍ, QUIERO EL MEGA PACK
          </button>
          <p className="text-sm text-gray-400 italic" data-id="element-152">
            La opción más elegida por aspirantes que quieren prepararse de
            verdad
          </p>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-xs md:text-sm font-medium" data-id="element-153">
          <div className="flex items-center gap-2" data-id="element-154">
            <LockIcon className="w-4 h-4 text-orange-400" data-id="element-155" />
            <span data-id="element-156">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-157">
            <ClockIcon className="w-4 h-4 text-orange-400" data-id="element-158" />
            <span data-id="element-159">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5 text-[10px] md:text-xs" data-id="element-160">
            <ShieldCheckIcon className="w-3 h-3 text-blue-400" data-id="element-161" />
            <span data-id="element-162">Garantía 7 días</span>
            <span className="text-gray-600 mx-0.5" data-id="element-163">•</span>
            <CreditCardIcon className="w-3 h-3 text-blue-400" data-id="element-164" />
            <span data-id="element-165">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}